<template>
  <div class="msg-dialog">
    <el-dialog :title="title" :visible.sync="visible" :width="dWidth" :before-close="handleClose" @closed="closeDialog" @open="openDialog" :destroy-on-close="true" center :top="dtop" :modal-append-to-body="modalAppend" :append-to-body="isAppend">
      <div class="md-content">
        <slot></slot>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog(false)" round>{{$t(buttonName[1])}}</el-button>
        <el-button type="primary" @click="closeDialog(true)" round :disabled="!isDefine">{{$t(buttonName[0])}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 外部引用组件
 * <msg-dialog :dialogVisible="dialogVisible" @closeDialog="closeDialog">$添加的内容$</msg-dialog>
 * 消息弹窗提示使用
 * 将需要提示的内容添加到<slot></slot>中
 */
export default {
  name: "MsgDialog",
  props: {
    title: {
      type: String,
      default: "标 题"
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dWidth: {
      type: String,
      default: "400px"
    },
    dtop: {
      type: String,
      default: "0vh"
    },
    buttonName: {
      type: Array,
      default: () => ['basics.Confirm', 'basics.Cancel']
    },
    isDefine: {
      type: Boolean,
      default: true
    },
    modalAppend: {
      type: Boolean,
      default: true
    },
    isAppend: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    // 弹窗关闭时调用
    closeDialog(isConfirm) {
      this.visible = false;
      this.$emit('closeDialog', isConfirm);
    },
    // 弹窗开启时调用
    openDialog() {

    },
    // 弹窗关闭时回调，会暂停 Dialog 的关闭
    handleClose() {
      this.visible = false;
      this.$emit('closeDialog');
    }
  },
  watch: {
    dialogVisible() {
      this.visible = this.dialogVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-dialog {
  /deep/ .el-dialog {
    margin: 0px;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  /deep/ .el-dialog__header {
    padding: 16px;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(
        270deg,
        #86eae7 0%,
        #4cccf0 45%,
        #11adf8 100%
      ),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
    .el-dialog__title {
      font-size: 20px;
      color: #fff;
    }
  }
  /deep/ .el-dialog__body {
    padding: 16px;
    overflow: hidden;
  }
  /deep/ .el-dialog__footer {
    padding: 0px 16px 16px;
    border-radius: 0px 0px 8px 8px;
    /deep/ .el-button + .el-button {
      margin-left: 20px;
    }
  }
}
</style>